import {
    Autocomplete,
    AutocompleteItem,
    DateRangePicker,
    Input,
} from "@heroui/react";
import { FilterCard } from "@/components/data-table";
import { parseDate, getLocalTimeZone, today } from "@internationalized/date";

/**
 * Filter component for Production Data page
 * Backend: productions/data
 * Filters: warehouse_id, material_id, start_date, end_date
 *
 * @param {Object} filterOptions - Options for select filters
 *   - warehouses: Array of { value, title }
 *   - materials: Array of { value, title }
 */
const FilterData = ({ table, initialFilters, filterOptions = {} }) => {
    const { filterPanel } = table;
    const { isOpen, pending, setPending, apply, clear } = filterPanel;

    const { warehouses = [], materials = [] } = filterOptions;

    // Handle clear
    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    // Derive dateRange from pending
    const dateRange =
        pending.start_date && pending.end_date
            ? {
                  start: parseDate(pending.start_date),
                  end: parseDate(pending.end_date),
              }
            : null;

    // Handle date range change
    const handleDateRangeChange = (range) => {
        if (range) {
            setPending((prev) => ({
                ...prev,
                start_date: range.start.toString(),
                end_date: range.end.toString(),
            }));
        } else {
            setPending((prev) => ({
                ...prev,
                start_date: "",
                end_date: "",
            }));
        }
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            {/* Rentang Tanggal */}
            <DateRangePicker
                label="Rentang Tanggal"
                value={dateRange}
                onChange={handleDateRangeChange}
                maxValue={today(getLocalTimeZone())}
                variant="flat"
            />

            {/* Nomor Produksi */}
            <Input
                label="Nomor Produksi"
                placeholder="Cari nomor produksi..."
                value={pending.production_number || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({ ...prev, production_number: val }))
                }
                variant="flat"
                isClearable
            />

            {/* Produk Hasil */}
            <Autocomplete
                label="Produk Hasil"
                placeholder="Semua item"
                selectedKey={
                    pending.material_id ? String(pending.material_id) : null
                }
                onSelectionChange={(key) =>
                    setPending((prev) => ({
                        ...prev,
                        material_id: key || "",
                    }))
                }
                variant="flat"
                isClearable
            >
                {materials.map((m) => (
                    <AutocompleteItem key={String(m.value)} value={m.value}>
                        {m.title}
                    </AutocompleteItem>
                ))}
            </Autocomplete>

            {/* Gudang Tujuan */}
            <Autocomplete
                label="Gudang Tujuan"
                placeholder="Semua gudang"
                selectedKey={
                    pending.warehouse_id ? String(pending.warehouse_id) : null
                }
                onSelectionChange={(key) =>
                    setPending((prev) => ({
                        ...prev,
                        warehouse_id: key || "",
                    }))
                }
                variant="flat"
                isClearable
            >
                {warehouses.map((w) => (
                    <AutocompleteItem key={String(w.value)} value={w.value}>
                        {w.title}
                    </AutocompleteItem>
                ))}
            </Autocomplete>
        </FilterCard>
    );
};

export default FilterData;
